module.exports = __webpack_public_path__ + "img/image6.a4d849ef.png";